/** Marks a live region that an open dialog leaves visible to screen readers when it hides the page. */
export const ANNOUNCER_ATTRIBUTE = 'data-announcer';

export const ANNOUNCER_PROPS = { [ANNOUNCER_ATTRIBUTE]: '' };
